import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
`;

export const Row = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;
